export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-key-722c672634f4660e913c88ca638811b4.svg";